// Equivalent vanilla du whileInView Framer Motion du prototype Next.js.
// Ajoute .is-visible sur tout .reveal qui entre dans le viewport (une seule fois).
// Voir docs/reference-style-nextjs.md §3 / §6 pour l'origine des valeurs.
(function () {
  var targets = document.querySelectorAll('.reveal');
  if (!targets.length) return;

  if (!('IntersectionObserver' in window)) {
    targets.forEach(function (el) { el.classList.add('is-visible'); });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.1 }
  );

  targets.forEach(function (el) { observer.observe(el); });
})();
